import apiConfig from "./api.config.js";

const appConfig = {
  appName: "Onnspot",
  storagePrefix: "onnspot_",
  apiConfig,
  routes: {
    authenticatedEntryPath: "/dashboard",
    unAuthenticatedEntryPath: "/",
  },
};

export default appConfig;
